export interface Money { amount: number; currency: 'CNY' }
export interface NailService {
  id: string; categoryId: string; categoryName: string; name: string; description: string
  detailDescription: string; detailImageUrls: string[]
  durationMinutes: number; price: Money; coverUrl: string | null; enabled: boolean
}

const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '')
const assetByService: Record<string, string> = {
  'service-gel': '/images/hero.png',
  'service-french': '/images/french.png',
  'service-cat-eye': '/images/cat-eye.png',
  'service-hand-care': '/images/hand-care.png'
}
const categoryNames: Record<string, string> = {
  basic: '基础美甲', design: '款式设计', extension: '延长定制', care: '护理卸甲'
}

export const categoryLabel = (service: NailService) => service.categoryName || categoryNames[service.categoryId] || '精选商品'
export const imageUrl = (url?: string | null) => url?.startsWith('/uploads/') ? `${apiBaseUrl}${url}` : url || ''
export const serviceCover = (service: NailService) => imageUrl(service.coverUrl) || imageUrl(service.detailImageUrls?.[0]) || assetByService[service.id] || ''
export const formatMoney = (money: Money) => new Intl.NumberFormat('zh-CN', {
  style: 'currency', currency: money.currency,
  minimumFractionDigits: money.amount % 100 === 0 ? 0 : 2,
  maximumFractionDigits: 2
}).format(money.amount / 100)

export const requestApi = async <T,>(path: string, init?: RequestInit): Promise<T> => {
  const response = await fetch(`${apiBaseUrl}/api/v1${path}`, {
    ...init,
    headers: { Accept: 'application/json', ...(init?.body !== undefined ? { 'Content-Type': 'application/json' } : {}), ...init?.headers }
  })
  const body = await response.json().catch(() => null) as { data?: T; error?: { message?: string } } | null
  if (!response.ok || !body?.data) {
    /**
     * F09：登录态失效（401）时清除本地会话，并抛出带标记的错误，
     * 让账户中心能立即回到“验证码登录”界面并给出中文提示，而不是停留在旧的已登录界面。
     */
    if (response.status === 401 && init?.headers && 'Authorization' in (init.headers as Record<string, string>)) {
      window.localStorage.removeItem('nail-web.session.v1')
      const error = new Error('登录已过期，请重新用手机号验证码登录')
      ;(error as Error & { code?: string }).code = 'SESSION_EXPIRED'
      throw error
    }
    throw new Error(body?.error?.message ?? '服务暂时不可用，请稍后重试')
  }
  return body.data
}
